import React from 'react';

import { Box } from '@core';
import { StoreRatingsWithCount } from '@components';

const RatingsCard = () => (
  <Box py={52} px={39}>
    <Box pb={56}>
      <StoreRatingsWithCount.Google />
    </Box>
    <StoreRatingsWithCount.Apple />
  </Box>
);

export default RatingsCard;
